import { render, staticRenderFns } from "./RolesListAddNew.vue?vue&type=template&id=eff6e38e"
import script from "./RolesListAddNew.vue?vue&type=script&lang=js"
export * from "./RolesListAddNew.vue?vue&type=script&lang=js"
import style0 from "./RolesListAddNew.vue?vue&type=style&index=0&id=eff6e38e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports